import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Alert, AlertType } from './alert.model';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private readonly defaultDuration = 3000;

  private readonly alertSubject = new BehaviorSubject<Alert>({
    message: '',
    type: 'success',
    duration: this.defaultDuration,
    isVisible: false,
  });

  readonly alert$ = this.alertSubject.asObservable();

  constructor() {}

  showAlert(message: string, type: AlertType = 'success', duration: number = this.defaultDuration): void {
    this.alertSubject.next({
      message,
      type,
      duration,
      isVisible: true,
    });

    setTimeout(() => this.hideAlert(), duration);
  }

  hideAlert(): void {
    this.alertSubject.next({
      message: '',
      type: 'success',
      duration: 0,
      isVisible: false,
    });
  }
}
